import React from 'react';
import '../../../styles/global.css';

function CubeAquarium() {
  return (
    <div className="body-container">
      <h1>Cube Aquarium</h1>
      <h4>March 2021 - May 2021</h4>
      <h2>Explore the project <a href='https://newart.city/catalog/cubeaquarium' target="_blank" rel="noopener noreferrer">here</a>.</h2>
      <p> <i>Cube Aquarium</i> is a virtual art installation created for the group showcase, <i>Soundscapes</i>, a joint collaboration between UC Berkeley Art Practice students and UC Berkeley Orchestra musicians.</p>
      <p>Models, rigs, and animation were made using Autodesk Maya.</p>
      
      <h3>Models and Rigs:</h3>
      <div className='imgs-grid'>
        <img src={require('./assets/shrimp_model.png')} />
        <img src={require('./assets/shrimp_rig.png')} />
      </div>
      <div className='imgs-grid'>
        <img src={require('./assets/guppy_model.png')} />
        <img src={require('./assets/guppy_rig.png')} />
      </div>
      <div className='imgs-grid'>
        <img src={require('./assets/snail_model.png')} />
        <img src={require('./assets/snail_rig.png')} />
      </div>
      
      <h3>Shrimp close-ups:</h3>
      <div className='imgs-grid'>
        <img src={require('./assets/shrimps1.jpg')} />
        <img src={require('./assets/shrimps2.jpg')} />
        <img src={require('./assets/shrimps3.jpg')} />
      </div>
      
    </div>
  );
};

export default CubeAquarium;
